export default __webpack_public_path__ + "static/media/Warning.c4ecf69a.svg";